export const SAVE_NEW_NOTIFICATION = "SAVE_NEW_NOTIFICATION";
export const ADD_NEW_NOTIFICATION = "ADD_NEW_NOTIFICATION";
export const READ_ALL_NOTIFICATIONS = "READ_ALL_NOTIFICATIONS";
